export const frontDate = (date) => {
  if (date) {
    const yyyy = date.slice(0, 4)
    const MM = date.slice(5, 7)
    const dd = date.slice(8, 10)

    return `${dd}/${MM}/${yyyy}`
  }
  return null
}

export const apiDate = (date) => {
  if (date) {
    const dd = date.slice(0, 2)
    const MM = date.slice(3, 5)
    const yyyy = date.slice(6, 10)

    return `${yyyy}-${MM}-${dd}`
  }

  return null
}
